/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Input } from "../../../components";
import { Calendar } from "react-multi-date-picker";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import {
  GetSlotsBySport,
  GetCourtList,
} from "../../../utilities/api/courts";
import { format } from "date-fns";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { messages } from "../../../utilities/Messages";
const getMessage = messages.courts;

const CustomerCourtBookingStep2 = (props: any) => {
  const {
    courtBookingData,
    setCourtBookingData,
    setCurrentStep,
    isReschedule = false,
  } = props;
  const navigate = useNavigate();
  const { AllSportsData, sportErrorMessage } = useAppSelector((state) => state.sportList);
  const [courtList, setCourtList] = useState([]) as any;
  const [date, setDate] = useState(
    format(
      !isReschedule
        ? new Date()
        : new Date(
          courtBookingData?.bookingDate?.split("/").reverse().join("/")
        ),
      "yyyy-MM-dd"
    )
  );
  const [slots, setSlots] = useState({}) as any;
  if (sportErrorMessage) {
    toast.error(sportErrorMessage.message)
  }
  const sportName = AllSportsData.find(
    (item: any) => item.id == courtBookingData.sportId
  )?.name as string;

  const GetCourts = async () => {
    const result = await GetCourtList(courtBookingData.facilityId.toString(), courtBookingData.sportId.toString());
    if (result.statusCode === 200) {
      setCourtList(result.data.rows);
    } else {
      toast.error(result.response?.data?.message || "Failed to fetch courts");
    }
  };

  const GetSlots = async (courtId?: number) => {
    const id = courtId ?? courtBookingData.courtId;
    if (!id) return;
    const result = await GetSlotsBySport(
      courtBookingData.facilityId.toString(),
      courtBookingData.sportId.toString(),
      date,
      id.toString()
    );
    if (result.statusCode === 200) {
      setSlots(result.data);
    }
  };

  useEffect(() => {
    if (courtBookingData.facilityId && courtBookingData.sportId) {
      if (isReschedule) {
        GetCourts();
        GetSlots();
      } else {
        setCourtList([]);
        setSlots({});
        setCourtBookingData((prev: any) => ({ ...prev, courtId: null, selectedSlots: [] }));
        GetCourts();
      }
    }
  }, [courtBookingData.facilityId, courtBookingData.sportId]);

  useEffect(() => {
    if (!isReschedule && courtBookingData.courtId && date) {
      GetSlots();
    }
  }, [date, courtBookingData.courtId]);

  const handleDateChange = (e: any) => {
    setDate(e.format("YYYY-MM-DD"));
    setCourtBookingData({ ...courtBookingData, selectedSlots: [] });
  };

  const handleCourtSelect = (courtId: number) => {
    if (isReschedule) return; // prevent change
    setCourtBookingData({ ...courtBookingData, courtId, selectedSlots: [] });
  };

  const handleChecked = (checked: boolean, data: any) => {
    data.bookingDate = date;
    let temp = courtBookingData.selectedSlots.length
      ? courtBookingData.selectedSlots.map((elem: any) => elem.fromTime)
      : [];
    let addOrNot = temp.includes(data.fromTime);

    if (!isReschedule) {
      checked
        ? addOrNot
          ? setCourtBookingData({ ...courtBookingData })
          : setCourtBookingData({
            ...courtBookingData,
            selectedSlots: [...courtBookingData.selectedSlots, data],
          })
        : setCourtBookingData({
          ...courtBookingData,
          selectedSlots: courtBookingData.selectedSlots.filter(
            (elem: any) => elem.fromTime !== data.fromTime
          ),
        });
    } else {
      checked
        ? setCourtBookingData({
          ...courtBookingData,
          selectedSlots: [
            {
              id: courtBookingData?.slotId,
              bookingDate: courtBookingData?.bookingDate
                ?.split("/")
                .reverse()
                .join("-"),
              fromTime: data?.fromTime,
              toTime: data?.toTime,
              ratePerSlot: data?.ratePerSlot,
            },
          ],
        })
        : setCourtBookingData({ ...courtBookingData, selectedSlots: [] });

    }
  };

  const handleCancel = () => {
    if (!isReschedule) {
      navigate("/customer-dashboard");
    } else {
      navigate("/customer-court-booking-details", {
        state: courtBookingData?.id,
      });
    }
  };

  const handleContinue = () => {
    if (!isReschedule) {
      courtBookingData?.selectedSlots?.length >= 2
        ? setCurrentStep((_oldVal: number) => {
          if (_oldVal < 2) {
            return ++_oldVal;
          } else {
            return _oldVal;
          }
        })
        : toast.error(getMessage.slot_minLength);
    } else {
      courtBookingData?.selectedSlots?.length === 1
        ? setCurrentStep((_oldVal: number) => {
          if (_oldVal < 1) {
            return ++_oldVal;
          } else {
            return _oldVal;
          }
        })
        : toast.error(getMessage.slot_minLengthOne);
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <Row className="row-mb align-items-center">
          <Col lg={12}>
            {!isReschedule && (
              <>
                <h4 className="fs-5 fw-semibold mb-4 text-start">
                  {sportName}
                </h4>

              </>
            )}
            <div className="slot-selection">
              <Row>
                {!isReschedule ? (
                  <Col lg={3}>
                    <div className="text-start mb-3">
                      <label htmlFor="" className="form-label fw-semibold">
                        Select Date
                      </label>
                      <Calendar
                        format="dd-MM-yyyy"
                        className=" ms-2"
                        value={new Date(date)}
                        onChange={(e: any) => handleDateChange(e)}
                        minDate={new Date()}
                        maxDate={new Date().setDate(
                          new Date().getDate() + (slots.preBookingMaxDays || 30) - 1
                        )}
                      />
                    </div>
                  </Col>
                ) : (
                  <h4 className="fs-5 fw-semibold mb-4 text-start">
                    Reschedule Date : {courtBookingData?.bookingDate}
                  </h4>
                )}
                <Col lg={9}>
                  <label htmlFor="" className="form-label mb-4 fw-semibold">Select Court</label>
                  <div className="available-slot d-flex flex-wrap gap-3 mb-4">
                    {courtList?.map((court: any, index: number) => {
                      return (
                        <span style={{ width: '150px' }} key={"court" + index}>
                          <Input
                            onChange={(e: any) => handleCourtSelect(e.target.value)}
                            checked={courtBookingData.courtId == court.id}
                            id={"court" + court.id}
                            type="radio"
                            name="court"
                            className="btn-check"
                            value={court.id}
                          />
                          <label htmlFor={"court" + court.id} className="bg-white border border-2 btn btn-sm p-3 w-100">
                            <div className="text-center">
                              <span className="d-block fw-semibold">{court.name}</span>
                            </div>
                          </label>
                        </span>
                      )
                    })}
                  </div>
                  {courtBookingData.courtId && (
                    <>
                  <label htmlFor="" className="form-label mb-4 fw-semibold">Available Slots</label>
                  <div className="available-slot d-flex flex-wrap gap-2">
                    {slots.timeSlots?.length ? (
                      slots.timeSlots?.map((item: any, index: number) => {
                        return (
                          <span
                            style={{ width: "110px" }}
                            key={"check" + index}
                          >
                            <Input
                              onChange={(e: any) =>
                                handleChecked(e.target.checked, item)
                              }
                              checked={
                                courtBookingData.selectedSlots?.find(
                                  (elem: any) => elem.fromTime === item.fromTime
                                )
                                  ? true
                                  : false
                              }
                              id={item.fromTime}
                              type="checkbox"
                              name={item.fromTime}
                              className="btn-check"
                            />
                            <label
                              htmlFor={item.fromTime}
                              className="bg-light bg-opacity-50 border border-2 btn btn-sm p-1 w-100"
                            >
                              <div className="slot-box text-start">
                                <span className="d-block">
                                  {item.fromTime} to {item.toTime}
                                </span>
                                <span className="text-primary">
                                  <span className="rupees-symbol">&#8377;</span>{" "}
                                  {item.ratePerSlot.toFixed(2)}
                                </span>{" "}
                                {item.discountPercent && (
                                  <del>
                                    <span>
                                      <span className="rupees-symbol">
                                        &#8377;
                                      </span>{" "}
                                      {item.actualRatePerSlot.toFixed(2)}
                                    </span>
                                  </del>
                                )}
                              </div>
                            </label>
                          </span>
                        );
                      })
                    ) : (
                      <table>
                        <tbody>
                          <tr>
                            <td colSpan={5} className="text-danger">
                              No Slots Available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                  </>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col lg={6} className="text-start">
            <Button
              onClick={handleCancel}
              type="button"
              bname="Cancel"
              name="cancel"
              id="cancel"
              className="btn btn-light rounded-1"
            ></Button>
          </Col>
          <Col lg={6} className="text-end">
            <Button
              onClick={handleContinue}
              type="button"
              bname="Continue"
              name="continue"
              id="continue"
              className="btn btn-primary rounded-1"
            ></Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export { CustomerCourtBookingStep2 };
